import { render, staticRenderFns } from "./renqun.vue?vue&type=template&id=0c9429c9&scoped=true"
import script from "./renqun.vue?vue&type=script&lang=js"
export * from "./renqun.vue?vue&type=script&lang=js"
import style0 from "./renqun.vue?vue&type=style&index=0&id=0c9429c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9429c9",
  null
  
)

export default component.exports